module.exports = __webpack_public_path__ + "static/media/whatsapp-small.a022afd9.svg";